import React, { useState } from "react";

function ContactForm() {
  // ✅ State variables for form fields and messages
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [responseMsg, setResponseMsg] = useState({ type: "", text: "" });

  // ✅ HANDLE SUBMIT FUNCTION
  const handleSubmit = async (e) => {
    e.preventDefault(); // Stop HTML form POST
    e.stopPropagation(); // Optional but prevents event bubbling
    // ⛔ Prevent browser's default form action

    try {
      const response = await fetch("http://localhost:5000/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          subject,
          contact_number: contactNumber, // match your backend field
          message,
          captcha,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setResponseMsg({ type: "success", text: data.message });
        // Clear form fields
        setName("");
        setEmail("");
        setSubject("");
        setContactNumber("");
        setMessage("");
        setCaptcha("");
      } else {
        setResponseMsg({ type: "error", text: "Failed to send message." });
      }
    } catch (error) {
      console.error("Submission error:", error);
      setResponseMsg({
        type: "error",
        text: "An unexpected error occurred.",
      });
    }
  };

  return (
    <>
      {responseMsg.text && (
        <div
          className={`alert mt-3 ${
            responseMsg.type === "success" ? "alert-success" : "alert-danger"
          }`}
        >
          {responseMsg.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="quform-elements">
          <div className="row">
            <div className="col-md-6">
              <div className="quform-element form-group">
                <label htmlFor="name">
                  Your Name <span className="quform-required">*</span>
                </label>
                <div className="quform-input">
                  <input
                    className="form-control"
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Your name here"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="quform-element form-group">
                <label htmlFor="email">
                  Your Email <span className="quform-required">*</span>
                </label>
                <div className="quform-input">
                  <input
                    className="form-control"
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Your email here"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="quform-element form-group">
                <label htmlFor="subject">
                  Your Subject <span className="quform-required">*</span>
                </label>
                <div className="quform-input">
                  <input
                    className="form-control"
                    id="subject"
                    type="text"
                    name="subject"
                    placeholder="Your subject here"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="quform-element form-group">
                <label htmlFor="phone">Contact Number</label>
                <div className="quform-input">
                  <input
                    className="form-control"
                    id="phone"
                    type="text"
                    name="contact_number"
                    placeholder="Your phone here"
                    value={contactNumber}
                    onChange={(e) => setContactNumber(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="quform-element form-group">
                <label htmlFor="message">
                  Message <span className="quform-required">*</span>
                </label>
                <div className="quform-input">
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    rows="3"
                    placeholder="Tell us a few words"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="quform-element">
                <div className="form-group">
                  <div className="quform-input">
                    <input
                      className="form-control"
                      id="type_the_word"
                      type="text"
                      name="type_the_word"
                      placeholder="Type the below word"
                      value={captcha}
                      onChange={(e) => setCaptcha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="quform-captcha-inner">
                    <img
                      src="/quform/images/captcha/courier-new-light.png"
                      alt="captcha"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="quform-submit-inner">
                <button type="submit" className="btn-style3 border-0">
                  <span>Send Message</span>
                </button>
              </div>
              <div className="quform-loading-wrap text-start">
                <span className="quform-loading"></span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default ContactForm;
